import { Controller } from '@hotwired/stimulus';

// Handles enabling the SSO button when a valid email with a known domain is entered.
export default class extends Controller {
  static targets = [ 'email', 'button', 'error', 'fields', 'label' ];
  static values = {
    settings: Array
  };

  connect() {
    this.disableButton();
  }

  handleInput(event) {
    const value = event.target.value.trim();

    if (value === '') {
      this.clearError();
      this.disableButton();
      return;
    }

    if (!this.validEmail(value)) {
      this.showError('Enter a valid email address.');
      this.disableButton();
      return;
    }

    const domain = value.split('@')[1].toLowerCase();
    const settings = this.settingsValue || [];
    const matchedSetting = settings.find((setting) => setting.domain === domain);

    if (!matchedSetting) {
      this.showError("We couldn't find an SSO provider for that email domain.");
      this.disableButton();
      return;
    }

    this.clearError();
    this.enableButton(matchedSetting);
  }

  disableButton() {
    if (!this.hasButtonTarget) return;

    this.buttonTarget.classList.add('disabled');
    this.buttonTarget.setAttribute('aria-disabled', 'true');
    this.buttonTarget.removeAttribute('href');
    this.buttonTarget.dataset.domain = '';
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = 'Sign In';
    }
  }

  enableButton(setting) {
    if (!this.hasButtonTarget) return;

    this.buttonTarget.classList.remove('disabled');
    this.buttonTarget.removeAttribute('aria-disabled');
    this.buttonTarget.href = setting.init_url;
    this.buttonTarget.dataset.domain = setting.domain;
    // if (this.hasLabelTarget) {
    //   this.labelTarget.textContent = `Sign In with ${setting.name}`;
    // }
  }

  showError(message) {
    if (!this.hasErrorTarget) return;

    this.errorTarget.textContent = message;
    if (message && this.hasFieldsTarget) {
      this.fieldsTarget.classList.add('has-error');
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = '';
    }

    if (this.hasFieldsTarget) {
      this.fieldsTarget.classList.remove('has-error');
    }
  }

  validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }
}
